import React from 'react';
import { FadeIn } from './FadeIn';
import { motion } from 'framer-motion';
export function TomosSection() {
  const tomos = [{
    icon: '😮‍💨',
    title: 'Tomo 1',
    subtitle: 'Rescate de Ansiedad 911',
    desc: 'Protocolos de emergencia sonora para calmar tu sistema nervioso en 5 minutos',
    color: 'from-[#7c3aed]/10 to-transparent',
    border: 'border-t-[#7c3aed]'
  }, {
    icon: '😴',
    title: 'Tomo 2',
    subtitle: 'Arquitectura del Sueño Profundo',
    desc: 'El sistema de frecuencias Delta para reprogramar tu descanso y despertar renovado cada mañana',
    color: 'from-[#a78bfa]/10 to-transparent',
    border: 'border-t-[#a78bfa]'
  }, {
    icon: '🧠',
    title: 'Tomo 3',
    subtitle: 'Enfoque Ultra & Productividad',
    desc: 'Frecuencias Gamma y Beta para activar tu mente de alto rendimiento sin cafeína ni estimulantes',
    color: 'from-[#5b21b6]/10 to-transparent',
    border: 'border-t-[#5b21b6]'
  }, {
    icon: '🏠',
    title: 'Tomo 4',
    subtitle: 'Sanación del Entorno',
    desc: 'Cómo transformar tu hogar y espacio de trabajo en un campo de alta vibración y paz profunda',
    color: 'from-[#4c1d95]/10 to-transparent',
    border: 'border-t-[#4c1d95]'
  }, {
    icon: '💪',
    title: 'Tomo 5',
    subtitle: 'Sonido para el Cuerpo Físico',
    desc: 'Frecuencias terapéuticas para aliviar el dolor, reducir la inflamación y acelerar la recuperación',
    color: 'from-[#7c3aed]/10 to-transparent',
    border: 'border-t-[#7c3aed]'
  }, {
    icon: '🦋',
    title: 'Tomo 6',
    subtitle: 'Manifiesto de Transformación',
    desc: 'El plan de integración de 90 días para convertir la terapia de sonido en tu nuevo sistema operativo de vida',
    color: 'from-[#a78bfa]/10 to-transparent',
    border: 'border-t-[#a78bfa]'
  }];
  return <section className="py-8 md:py-16 px-4 max-w-6xl mx-auto" data-id="element-444">
      <FadeIn data-id="element-445">
        <h2 className="text-2xl md:text-5xl font-black text-[#1f1b16] text-center mb-6 md:mb-14 flex items-center justify-center gap-3 md:gap-4" data-id="element-446">
          <span className="text-3xl md:text-5xl drop-shadow-[0_0_15px_rgba(124,58,237,0.3)]" data-id="element-447">
            📚
          </span>{' '}
          LOS 6 TOMOS
        </h2>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-8" data-id="element-448">
        {tomos.map((tomo, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-449">
            <motion.div whileHover={{
          y: -5,
          scale: 1.02
        }} transition={{
          type: 'spring',
          stiffness: 300
        }} className={`bg-[#faf7f2] border border-[#e7dfce] ${tomo.border} border-t-4 hover:border-[#7c3aed] transition-all rounded-2xl p-4 md:p-8 h-full flex flex-col relative overflow-hidden shadow-sm hover:shadow-xl`} data-id="element-450">
              <div className={`absolute inset-0 bg-gradient-to-b ${tomo.color} opacity-50 pointer-events-none`} data-id="element-451"></div>

              <div className="absolute top-3 right-3 md:top-4 md:right-4 text-[10px] md:text-xs font-black tracking-widest text-[#5b21b6] bg-[#f5efe4] px-2 py-0.5 md:px-3 md:py-1 rounded-full border border-[#e7dfce]" data-id="element-452">
                TOMO 0{index + 1}
              </div>

              <div className="text-4xl md:text-6xl mb-3 md:mb-6 relative z-10 drop-shadow-sm" data-id="element-453">
                {tomo.icon}
              </div>

              <h3 className="text-lg md:text-xl font-black text-[#1f1b16] mb-1.5 md:mb-2 relative z-10" data-id="element-454">
                {tomo.subtitle}
              </h3>

              <p className="text-sm md:text-base text-[#6b6358] font-medium leading-relaxed flex-grow relative z-10" data-id="element-455">
                {tomo.desc}
              </p>
            </motion.div>
          </FadeIn>)}
      </div>
    </section>;
}